import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {DefaultApi} from "./service/default.api";
import {PluginListModule} from "./plugin-list/plugin-list.module";
import {Router, RouterModule} from "@angular/router";
import {ROUTES} from "./app.routes";
import {Home} from "./home";
import {Redirection} from "../../redirection";
import {NoContent} from "./no-content";
import {SocialLoginAuthModule} from "./social-login";
import {AuthInterceptor} from "./interceptors/AuthInterceptor";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {RecoveryModule} from './recovery';
import {AcceptCookieModule} from './accept-cookie';

@NgModule({
    bootstrap: [AppComponent],
    declarations: [
        AppComponent,
        Home,
        Redirection,
        NoContent
    ],
    imports: [
        AcceptCookieModule,
        BrowserAnimationsModule,
        BrowserModule,
        AppRoutingModule,
        PluginListModule,
        SocialLoginAuthModule,
        RouterModule.forRoot(ROUTES, {
            useHash: true,
            //relativeLinkResolution: 'legacy'
        }),
        RecoveryModule,
    ],
    providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: AuthInterceptor,
            multi: true,
            deps: [Router]
        },
        DefaultApi,
        {
            provide: 'authUrl',
            useValue: 'auth/sso/'
        }
    ]
})
export class AppModule { }
